import React from 'react';
import PropTypes from 'prop-types';
import Title from '../base/Title/Title';
import OverviewTable from '../base/Table/OverviewTable';
import OverviewTableRow from '../base/Table/OverviewTableRow';
import textTranslates from './translate.json';
import './ComplaintPreview.scss';

const ComplaintPreviewCustomerOverview = (props) => {
  
    return(
        <div
            id="complaintPreviewCustomerOverview"
            className="col-xs-12">
            <Title
                id="complaintPreviewCustomerOverviewTitle"
                className="complaint-preview-customer-overview-title"
                title="Dane kontrahenta" />
            <OverviewTable tableId="complaintPreviewCustomerOverviewData">
                <tbody>
                    {props.customer.type.value==="CorporateEntity" &&
                    <OverviewTableRow
                        id="companyName"
                        label={textTranslates.companyName}
                        value={props.customer.companyName}/>}
                    {props.customer.type.value==="CorporateEntity" &&
                    <OverviewTableRow
                        id="companyTax"
                        label={textTranslates.companyTax}
                        value={props.customer.companyTax}/>}
                  
                    <OverviewTableRow
                        id="customerName"
                        label={textTranslates.customerName}
                        value={`${props.customer.name} ${props.customer.surname}`}/>
                    <OverviewTableRow
                        id="customerEmail"
                        label={textTranslates.customerEmail}>
                        <a href={`mailto:${props.customer.email}`}>
                                {props.customer.email}
                        </a>
                    </OverviewTableRow>
                    <OverviewTableRow
                        id="customerPhone"
                        label={textTranslates.customerPhone}
                        value={props.customer.phone}/>
                    <OverviewTableRow
                        id="customerAddress"
                        label={textTranslates.customerAddress}>
                        <address>
                            {props.customer.street}, {props.customer.flatNumber!== "" ? `${props.customer.buildingNumber}/${props.customer.flatNumber}`: props.customer.buildingNumber}<br/>
                            {props.customer.city}, {props.customer.postalCode}<br/>
                            {props.customer.country} <br/>
                        </address>
                    </OverviewTableRow>
                </tbody>
            </OverviewTable>
        </div>
    );
};

ComplaintPreviewCustomerOverview.propTypes = {
    customer: PropTypes.shape({
        buildingNumber: PropTypes.string,
        city: PropTypes.string,
        companyName: PropTypes.string,
        companyTax: PropTypes.string,
        country: PropTypes.string,
        email: PropTypes.string,
        flatNumber: PropTypes.string,
        name: PropTypes.string,
        phone: PropTypes.string,
        postalCode: PropTypes.string,
        street: PropTypes.string,
        type: PropTypes.shape({
            value: PropTypes.string
        }),
    })
};

export default ComplaintPreviewCustomerOverview;


// WEBPACK FOOTER //
// ./src/components/ComplaintPreview/ComplaintPreviewCustomerOverview.js